// extracted by mini-css-extract-plugin
export default {"webWorkSection":"WebWork_webWorkSection__Hiiug","webWorkGalleryHolder":"WebWork_webWorkGalleryHolder__93HID"};